/** Disable the LoadingIndicator shipped by react-select */
export default function CustomLoadingIndicator(): null {
  return null;
}
